import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const ListViewSkeleton: React.FC = () => {
  const rowCount = 10;

  return (
    <div className="w-full overflow-x-auto text-xs p-4">
      <table className="w-full min-w-[600px] border-collapse rounded-lg overflow-hidden shadow-sm">
        <thead>
          <tr className="bg-gray-100">
            {[
              "",
              "Name",
              "Mobile Number",
              "Contact Person",
              "Assignee",
              "Source Type",
              "Status",
            ].map((heading, i) => (
              <th key={i} className="p-3 text-left text-gray-700 font-semibold">
                <Skeleton
                  width={heading ? `${heading.length * 8 + 20}px` : "20px"}
                  height={16}
                />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[...Array(rowCount)].map((_, idx) => (
            <tr key={idx} className="border-b">
              <td className="p-3">
                <Skeleton circle width={16} height={16} />
              </td>
              <td className="p-3">
                <Skeleton width="40%" height={16} />
              </td>
              <td className="p-3">
                <Skeleton width="30%" height={16} />
              </td>
              <td className="p-3">
                <Skeleton width="30%" height={16} />
              </td>
              <td className="p-3">
                <Skeleton width="25%" height={16} />
              </td>
              <td className="p-3">
                <Skeleton width="20%" height={16} />
              </td>
              <td className="p-3">
                <Skeleton width="20%" height={16} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListViewSkeleton;
